import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";
import { Forbidden } from "../pages/ErrorPages";

export default function ProtectedRoute({ children, perm }) {
  const { user, hasPerm } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" data-testid="auth-loading">
        <div className="w-full max-w-md space-y-4 p-8">
          <Skeleton className="h-16 w-16 rounded-full mx-auto" />
          <Skeleton className="h-6 w-3/4 mx-auto" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/connexion" state={{ from: location }} replace />;
  }
  if (user.must_change_password && location.pathname !== "/changer-mot-de-passe") {
    return <Navigate to="/changer-mot-de-passe" replace />;
  }
  if (perm && !hasPerm(perm)) {
    return <Forbidden />;
  }
  return children;
}
